import { useLazyQuery, useQuery } from 'react-apollo';

import { GetMainAppData } from './__queries__';
import { GET_MAIN_APP_DATA } from './queries';

export const getMainAppDataLazyQuery = () =>
  useLazyQuery<GetMainAppData>(GET_MAIN_APP_DATA, {
    fetchPolicy: 'network-only',
  });
export const getMainAppDataQuery = () =>
  useQuery<GetMainAppData>(GET_MAIN_APP_DATA, {
    fetchPolicy: 'network-only',
  });
